import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sum',
  standalone: true,
})
export class SumPipe implements PipeTransform {
  transform(values: number[]): number {
    return values.reduce((a, b) => a + b, 0);
  }
}
